<template>
  <div class="is-danger" v-if="err.has(id)">{{ err.first(id) }}</div>
</template>

<script>
export default {
  name: "ErrorMsg",
  props: ["err", "id"]
}
</script>


// WEBPACK FOOTER //
// ErrorMsg.vue?0717e1f2